/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/CancelUpdateAllotmentSize
 */
export interface CancelUpdateAllotmentSizeRequestBuilder extends BaseRequestBuilder<CancelUpdateAllotmentSizeRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(requestConfiguration?: RequestConfiguration<CancelUpdateAllotmentSizeRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<CancelUpdateAllotmentSizeRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface CancelUpdateAllotmentSizeRequestBuilderPostQueryParameters {
    id?: number;
}
/**
 * Uri template for the request builder.
 */
export const CancelUpdateAllotmentSizeRequestBuilderUriTemplate = "{+baseurl}/Allotment/CancelUpdateAllotmentSize?id={id}";
/**
 * Metadata for all the requests in the request builder.
 */
export const CancelUpdateAllotmentSizeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CancelUpdateAllotmentSizeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
